export const cartKeys = {
  all: ["cart"],
  cartItems: () => [...cartKeys.all, `/cart/items`],
};
